import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Logo } from "@/components/Header";

const PaymentCancel = () => {
  const { t } = useLang();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6 text-center">
      <div className="absolute top-6 left-6"><Logo /></div>
      <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.6 }}
        className="flex max-w-lg flex-col items-center gap-5" data-testid="payment-cancel">
        <XCircle className="h-20 w-20 text-destructive" />
        <h1 className="font-heading text-4xl font-bold tracking-tight text-primary">{t.cancel.title}</h1>
        <p className="text-lg leading-relaxed text-muted-foreground">{t.cancel.sub}</p>
        <Link to="/" data-testid="cancel-home-btn"
          className="mt-2 rounded-full bg-primary px-7 py-3.5 font-semibold text-primary-foreground transition-transform hover:bg-accent active:scale-95">
          {t.cancel.back}
        </Link>
      </motion.div>
    </div>
  );
};

export default PaymentCancel;
